import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PRIMARY, SECONDARY, Reveal } from "@/components/landing/shared";

export const FinalCTA = ({ startTeam, openGallery }) => (
  <section className="py-16 lg:py-24">
    <div className="mx-auto max-w-6xl px-4 sm:px-6">
      <Reveal>
        <div className="rb-grain relative overflow-hidden rounded-3xl border border-[color:var(--rb-border)] bg-[color:var(--rb-obsidian)] px-6 py-14 text-center sm:px-12">
          <div className="pointer-events-none absolute inset-0" style={{ backgroundImage: "radial-gradient(560px circle at 50% 0%, rgba(45,212,191,0.12), transparent 60%)" }} />
          <div className="relative">
            <h2 className="rb-display mx-auto max-w-2xl text-3xl font-semibold tracking-tight text-[color:var(--rb-text)] sm:text-4xl">Give your team a registry it can trust.</h2>
            <p className="mx-auto mt-3 max-w-xl text-[color:var(--rb-text-dim)]">Free for up to 5 seats. Scan, approve, and sync — no credit card required.</p>
            <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Button onClick={startTeam} className={`h-12 rounded-xl px-7 text-base ${PRIMARY}`} data-testid="landing-final-primary-cta">Start a team registry <ArrowRight className="ml-1.5 h-4 w-4" /></Button>
              <Button onClick={openGallery} className={`h-12 rounded-xl px-7 text-base ${SECONDARY}`} data-testid="landing-final-secondary-cta">Browse the free gallery</Button>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
